'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '1.1.0';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/build/packages/version.js
// module id = 2279
// module chunks = 0